<div class="checkbox-container">
  <label>
    <input
      type="checkbox"
      [formControl]="control!"
    />
    {{ label }}
  </label>
</div>
